export function normalizeUppercaseText<T extends string|null|undefined>(value:T,{trim=false}:{trim?:boolean}={}):T{
  if(value==null)return value;
  return (trim?value.trim():value).toLocaleUpperCase("pt-BR") as T;
}

export function formatReportUppercaseText(value:string|null|undefined){return normalizeUppercaseText(value)}
